<template>
    <div class="content-wrap">
        <div class="card">
            <progressBarchart
                class="progress-view"
                :title="item.title"
                v-for="(item, index) in arrServicePowerEvaScoreList"
                :key="index"
                :score="parseFloat(item.score)"
                :resultList="item.EvaScoreList"
                :type="true"
                @barchartClick="barchartClick"
            ></progressBarchart>
        </div>
        <!-- <div class="card">
            <progressBarchart
                class="progress-view"
                :title="item.title"
                v-for="(item, index) in arrServicePowerEvaScoreList2"
                :key="index"
                :score="parseFloat(item.score)"
                :resultList="item.EvaScoreList"
                :type="true"
            ></progressBarchart>
            <div class="card-detail">
                <div class="comment">
                    {{
                        arrServicePowerEvaScoreList2[0] ? arrServicePowerEvaScoreList2[0].content != null ? arrServicePowerEvaScoreList2[0].content:'设计合理，安装规范，安装规范产品外观非常美观' : ''
                    }}
                </div>
                <div class="audio-btn" @click="audioClick">
                    点击聆听客户语音评价
                    <img
                        class="audio-icon"
                        src="~@/assets/images/service/audio-icon.png"
                        alt=""
                    />
                    <audio ref="audio">
                        <source type="audio/mpeg" :src="this.arrServicePowerEvaScoreList2[0]?this.arrServicePowerEvaScoreList2[0].voice:''" />
                    </audio>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import progressBarchart from "@/page/service/components/progressbarchart";
import {Toast} from "mint-ui";
export default {
    name: "dataanalysis",
    components: {
        progressBarchart,
    },
    data() {
        return {
            voice:'',//播放路径
        };
    },
    created() {
        // let contract_id = this.$route.query.id;
        // this.$store.commit("loadSwitch", true);
        // this.$store.dispatch('serviceScoreDetail/getData',{contract_id}).then(() => {
        //     this.$store.commit("loadSwitch", false);
        // })
    },
    computed: {
        arrServicePowerEvaScoreList() {
            console.log(this.$store.state.serviceScoreDetail.service,'service');
            return this.$store.state.serviceScoreDetail.service;
        },
        arrServicePowerEvaScoreList2() {
            console.log(this.$store.state.serviceScoreDetail.customer,'customser');
            return this.$store.state.serviceScoreDetail.customer;
        },
    },
    methods: {
        // 控制点击柱形图
        barchartClick (name) {
            console.log(name)
            this.$emit('change')
            this.$router.push(`/service/scoredetail/questionanalysis?id=${this.$route.query.id}&project_name=${name}`)
        },
        audioClick() {
            let audio = this.$refs.audio
            if ( audio.paused ) {
                audio.play();
                Toast({
                    message: '正在播放',
                    duration: 1200
                });
            } else {
                Toast({
                    message: '已暂停',
                    duration: 1200
                });
                audio.pause();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.content-wrap {
    width: 93.6%;
    margin: 0 auto;
    background: #f0f4f1;
    overflow: hidden;

    .card {
        background: #fff;
        padding: 16px 24px 32px;
        border-radius: $commonRadius;
        margin-bottom: 28px;

        .card-detail {
            margin-top: 34px;
            padding-top: 22px;
            border-top: 2px dashed #f1f1f1;

            .card-detail-text {
                font-size: $baseSize;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: $viceText;
                line-height: 68px;
            }
            .comment {
                padding: 24px;
                min-height: 238px;
                border-radius: 16px;
                border: 2px solid #e2e2e2;
                font-size: 28px;
                font-weight: 400;
                color: #858585;
                line-height: 40px;
                margin-bottom: 24px;
            }
            .audio-btn {
                width: 100%;
                height: 72px;
                background: rgba(85, 170, 108, 0.2);
                border-radius: 36px;
                position: relative;

                font-size: $baseSize;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                text-align: center;
                color: #6c9276;
                line-height: 72px;
                margin-top: 8px;

                .audio-icon {
                    height: 44px;
                    width: 44px;
                    position: absolute;
                    left: 38px;
                    top: 14px;
                }
                audio {
                    position: absolute;
                    opacity: 0;
                }
            }
        }
    }
}

::v-deep .barchart-item:last-child {
    margin-bottom: 0 !important;
}
</style>
